<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      value: true,
    };
  },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}

#app {
  min-width: 1920px;
  height: 100vh;
  overflow: hidden;
}

body {
  font-family: pinfan;
}
</style>
